import CustomReactSelect from '@ui/select/react-select/custom-react-select';
import { reactSelectAdminStyles } from '@ui/select/react-select/react-select-styles';
import { REGISTRATION_STATUS_ENUM, REGISTRATION_STATUS_LABELS } from '../../types';
import OptionalComponent from '@ui/optional-component/optional-component';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import { components } from 'react-select';

// force the indicator display to match other filters in this view
const DropdownIndicator = (props: React.ComponentProps<typeof components.DropdownIndicator>) => (
  <components.DropdownIndicator {...props}>
    <Icon name={ICONS.KEYBOARD_ARROW_DOWN} size={12} />
  </components.DropdownIndicator>
);

const REGISTRATION_STATUS_FILTER_OPTIONS = Object.values(REGISTRATION_STATUS_ENUM).map((val) => ({
  label: REGISTRATION_STATUS_LABELS[val],
  value: val,
}));

const DEFAULT_UNSELECTED_FILTER = {
  label: 'Sort by attendance',
  value: null,
};

type RegistrantsStatusFilterParams = {
  registrationStatusFilter?: string;
  selectRegistrationStatusFilter?: (value: unknown) => void;
  isRegistration?: boolean;
};

const RegistrantsStatusFilter = ({
  registrationStatusFilter,
  selectRegistrationStatusFilter,
  isRegistration = true,
}: RegistrantsStatusFilterParams) => {
  return (
    <OptionalComponent display={!!isRegistration}>
      <CustomReactSelect
        wrapperClass="registrants-status-filter"
        isSearchable={false}
        placeholder="Sort by attendance"
        tabSelectsValue={false}
        value={
          REGISTRATION_STATUS_FILTER_OPTIONS.find((option) => option.value === registrationStatusFilter) ||
          DEFAULT_UNSELECTED_FILTER
        }
        onChange={selectRegistrationStatusFilter}
        components={{ DropdownIndicator }}
        options={REGISTRATION_STATUS_FILTER_OPTIONS}
        styles={reactSelectAdminStyles({
          container: () => ({ width: '164px' }),
          control: () => ({ height: '32px', border: '1px solid var(--gray-400)' }),
          singleValue: () => ({ width: '120px' }),
          dropdownIndicator: () => ({ padding: '4px' }),
          menu: () => ({ backgroundColor: 'var(--gray-900)' }),
          menuList: () => ({ backgroundColor: 'var(--gray-900)' }),
        })}
      />
    </OptionalComponent>
  );
};

export default RegistrantsStatusFilter;
